import React from 'react';
import { If } from 'react-if';
import routes from '../../routes';
import CheckInCard from '../../components/CheckInCard';
import Text from '../../i18n/Text';
import ItemList from '../../components/ItemList/ItemList';
import { useConfig } from '../../hooks/Configurator';
import Track from '../../components/Track';


const Splash = () => {
  const { checkin, itemList: items } = useConfig(({ bbGeneralOptions }) => bbGeneralOptions);

  return (
    <div>
      <div className="section">
        <div className="columns is-multiline is-centered">
          <h1 className="title is-2">
            <Text>SPLASH.HEADING</Text>
          </h1>
        </div>
      </div>

      <div className="section">
        <div className="columns is-multiline is-centered">
          <If condition={checkin.display}>
            <div className="column is-4">
              <Track name="splashPage.selectCheckIn">
                <CheckInCard {...checkin} url={routes.CheckIn} />
              </Track>
            </div>
          </If>

          <If condition={items.length > 0}>
            <ItemList items={items} />
          </If>
        </div>
      </div>

      <div className="section">
        <div className="columns is-multiline is-centered">
          <div className="column is-8">
            <p className="content is-5 has-text-centered">
              <Text>SPLASH.HELP</Text>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Splash;
